import { css } from "@emotion/react";

export const bingoGrid = css`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: var(--color-bg-warm);
  padding: 10px 12px;
  border-radius: var(--radius-md);
  border: 2px solid var(--color-border);
  box-shadow: 0 3px 6px var(--shadow-light);
  width: 100%;
  max-width: 100%;

  @media (max-width: 640px) {
    padding: 6px 8px;
    border-radius: var(--radius-sm);
  }
`;

export const bingoRow = css`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 2px;
`;

export const bingoCell = css`
  aspect-ratio: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--container-bg);
  color: var(--text-primary);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 1.4cqi;
  border-radius: 4px;
  min-width: 32px;
  min-height: 28px;
  border: 1px solid var(--color-border);

  @media (max-width: 640px) {
    font-size: 1.4cqi;
    min-width: 20px;
    min-height: 18px;
  }
`;

export const bingoCellEmpty = css`
  background: var(--color-bg-warm);
  border-style: dashed;
  color: transparent;
`;

export const bingoCellDrawn = css`
  background: var(--color-primary);
  color: #FFFFFF;
  font-weight: 700;
  border-color: transparent;
  box-shadow: 0 1px 3px rgba(192, 57, 43, 0.3);
`;

export const bingoCellEditable = css`
  outline: none;
  text-align: center;
  font-family: inherit;
  cursor: text;
  color: var(--text-primary);

  &:focus {
    border-color: var(--input-border-focus);
    box-shadow: 0 0 0 2px var(--selected-word-bg);
    background: var(--container-bg);
    color: var(--text-primary);
  }
`;

export const bingoCellEditableEmpty = css`
  color: transparent;

  &:focus {
    color: var(--text-primary);
  }
`;

export const bingoCellError = css`
  border-color: var(--color-error);
  background: var(--error-bg);

  &:focus {
    border-color: var(--color-error);
    box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.25);
  }
`;

export const bingoRowError = css`
  & > * {
    border-color: var(--color-error);
  }
`;

export const bingoGridStatus = css`
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-heading);
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 6px 14px;
  border-radius: var(--radius-full);
  align-self: flex-start;
  margin-bottom: 4px;
  color: var(--text-secondary);
  background: var(--color-bg-warm);
  border: 1px solid var(--color-border);
`;

export const bingoGridStatusWaitingOrUploaded = css`
  background: rgba(52, 152, 219, 0.1);
  color: var(--color-info);
  border-color: rgba(52, 152, 219, 0.3);
`;

export const bingoGridStatusExtracted = css`
  background: var(--success-bg);
  color: var(--success-text);
  border-color: currentColor;
`;

export const bingoGridStatusConfirmed = css`
  background: var(--success-bg);
  color: var(--success-text);
  border-color: currentColor;
`;

export const bingoGridStatusCancelled = css`
  background: var(--error-bg);
  color: var(--error-text);
  border-color: currentColor;
`;

export const bingoGridOverlay = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 8px;
  pointer-events: none;
`;

export const bingoGridOverlayBlur = css`
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  background: rgba(250, 248, 244, 0.4);
`;

export const bingoGridOverlayDim = css`
  background: rgba(0, 0, 0, 0.15);
`;

export const bingoGridValidateBtn = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  font-size: 1.5rem;
  padding: 18px 48px;

  &:hover:not(:disabled) {
    transform: translate(-50%, calc(-50% - 2px));
  }
`;

export const bingoGridEmpty = css`
  font-size: var(--text-sm);
  color: var(--text-secondary);
  padding: 12px 4px 4px;
  text-align: center;
`;

export const validateGridModalOverlay = css`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;

  @media (max-width: 640px) {
    padding: 12px;
  }
`;

export const validateGridModal = css`
  background: var(--container-bg);
  border-radius: var(--radius-xl);
  box-shadow: 0 8px 32px var(--shadow-dark);
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 640px) {
    max-width: 100%;
    padding: 16px;
  }
`;

export const validateGridModalTitle = css`
  font-family: var(--font-heading);
  font-size: var(--text-lg);
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
`;

export const validateGridModalContent = css`
  display: flex;
  gap: 24px;
  align-items: stretch;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

export const validateGridModalPhoto = css`
  flex: 1;
  min-width: 0;
  display: flex;
`;

export const validateGridModalImg = css`
  width: 100%;
  border-radius: var(--radius-sm);
  object-fit: contain;
`;

export const validateGridModalGrid = css`
  flex: 1;
  min-width: 0;
  display: flex;
`;

export const validateGridModalErrors = css`
  background: var(--error-bg);
  border: 1px solid var(--color-error);
  border-radius: var(--radius-sm);
  padding: 12px 16px;
  color: var(--error-text);
  font-size: var(--text-sm);
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const validateGridModalActions = css`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
`;
